const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      padding: '15px 0',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 1,
        backgroundColor: theme.getRgba(theme.colors[7], 0.25),
      },
    },
    noItems: {
      padding: '25px 0',
      width: '100%',
    },
    nav: {
      width: '100%',
      '& ul': {
        display: 'flex',
        width: '100%',
      },
      '& li': {
        width: '50%',
        padding: '10px 35px',
        fontSize: 14,
        position: 'relative',
        '&:not(:last-child)': {
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            height: '100%',
            width: 1,
            backgroundColor: theme.getRgba(theme.colors[7], 0.25),
          },
        },
        '&:first-child': {
          textAlign: 'right',
        },
      },
    },
    item: {
      color: theme.getRgba(theme.colors[1], 0.3),
      '&:hover': {
        color: theme.colors[1],
      },
    },
    disable: {
      pointerEvents: 'none',
      '& $item': {
        color: theme.colors[1],
      },
    },
    back: {
      position: 'absolute',
      top: '50%',
      left: 0,
      zIndex: 1,
      transform: 'translateY(-50%)',
      '& button': {
        color: theme.colors[1],
        textTransform: 'uppercase',
        fontSize: 10,
        display: 'flex',
        cursor: 'pointer',
      },
      '& svg': {
        width: 8,
        height: 15,
        fill: theme.colors[1],
        marginRight: 18,
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    back: {
      '& button': {
        padding: 10,
      },
      '& span': {
        display: 'none',
      },
    },
    nav: {
      width: 'auto',
      marginLeft: 'auto',
      '& ul': {
        width: 'auto',
      },
      '& li': {
        width: 'auto',
        padding: '10px',
      },
    },
  }

  return output
}
export default style
